import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import orderReducer from "./slices/orderSlice";
import appealReducer from "./slices/appealSlice";
import testReducer from "./slices/testSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    order: orderReducer,
    appeal: appealReducer,
    test: testReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
